(function () {
    'use strict';

    angular
        .module('admin')
        .controller('AdmProcessListController', AdmProcessListController);

    AdmProcessListController.$inject = ['AdmService','$uibModal'];

    function AdmProcessListController(AdmService, $uibModal) {
        var vm = this;
        vm.activate = activate;
        vm.getByFilter          = getByFilter;
        vm.search               = '';
        vm.queryFlag            = false;
        vm.deleteProcess        = deleteProcess;
        vm.openEditModal        = openEditModal;
        vm.processSelected      = '';
        vm.task                 = '';
        vm.getProcessForSelect  = getProcessForSelect;
        vm.getDepartments       = getDepartments;
        vm.departmentSelected   = '';
        vm.getAdmUsersStaff     = getAdmUsersStaff;
        vm.userSelected         = '';
        vm.getTooltipContent    = getTooltipContent;


        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function getByFilter()
        {
            vm.queryFlag        = false;
            vm.query            = {};
            vm.query['page']    = vm.page;
            if(typeof vm.departmentSelected !== 'undefined' && vm.departmentSelected !== '') {
                vm.query['department'] = vm.departmentSelected;
            }
            if(typeof vm.processSelected !== 'undefined' && vm.processSelected !== '') {
                vm.query['process'] = vm.processSelected;
            }
            if(typeof vm.userSelected !== 'undefined' && vm.userSelected !== '') {
                vm.query['user'] = vm.userSelected;
            }
            if(typeof vm.task !== 'undefined' && vm.task !== '') {
                vm.query['task'] = vm.task;
            }
            AdmService.getProcesses(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.processes        = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {

            });
        }

        function getProcessForSelect()
        {
            AdmService.getProcessesForSelect(vm.query).then(function(response){
                vm.selectProcesses    = response.data;
            });
        }

        function deleteProcess(process){
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to delete this process: ' + process.name+'?')
                .set('onok', function (){

                    AdmService.deleteProcess(process.id).then(function () {
                        vm.processes.splice(vm.processes.indexOf(process), 1);
                        alertify.notify('Process is successfully deleted', 'success', 3);
                    });
                })
                .show();
        }

        function openEditModal(process) {

            $uibModal.open({
                templateUrl: 'templates/adm/process/edit/template.modal.html',
                controller: 'AdmProcessEditController',
                controllerAs:'vm',
                size: 'lg',
                resolve:
                    {
                        process : function () {
                            return process;
                        },
                        admProcessList : function () {
                            return vm;
                        }
                    }
            });
        }

        function getDepartments()
        {
            vm.query = {};
            AdmService.getDepartmentsForSelect(vm.query).then(function(response){
                vm.departments = response.data;
            });
        }

        function getAdmUsersStaff()
        {
            AdmService.getAdmUsersStaff(vm.query).then(function(response){
                vm.admUsers  = response.data;
            }).catch(function(err) {

            });
        }

        function getTooltipContent(team)
        {
            vm.tooltipContent = '<p class="text-center">Tasks per person for this process</p>';
            angular.forEach(team, function(value, key) {
                vm.tooltipContent += '<div class="text-center" style="display: block !important; float: left !important; margin: 3px; text-align: center !important;"><img src="' + value.photo_url + '" style="width: 35px; height: 35px; border-radius: 50%; margin-bottom: 3px;"><p>' + value.total_tasks + '</p></div>';
            });
            return vm.tooltipContent;
        }

        function activate() {
            vm.getDepartments();
            vm.getProcessForSelect();
            vm.getAdmUsersStaff();
            vm.getByFilter();
        }
        vm.activate();
    }

})();